import { AppRequests } from "packages/shared/models/app-requests-model";
import React, { createContext, PropsWithChildren } from "react";

export const AppRequestsContext = createContext<null | AppRequests>(null);

export const AppRequestsProvider = ({ children, requests }: PropsWithChildren<{ requests: AppRequests }>) => {
    return <AppRequestsContext.Provider value={requests}>{children}</AppRequestsContext.Provider>;
};
